<template>
  <a-drawer
    :visible="visible"
    :title="`测试按键 - ${drawerData.name || ''}`"
    width="600"
    @close="$emit('close')"
  >
    <div v-if="drawerData.keys && drawerData.keys.length">
      <h4>按键列表</h4>
      <a-table
        :data-source="drawerData.keys"
        row-key="id"
        :pagination="false"
        size="small"
        bordered
      >
        <a-table-column
          key="name"
          title="名称"
          data-index="name"
        />
        <a-table-column
          key="displayName"
          title="显示名"
          data-index="displayName"
        />
        <a-table-column
          key="pulse"
          title="波形"
          width="200"
        >
          <template #default="scope">
            <template v-if="scope.pulse">
              <a-tooltip placement="topLeft">
                <template #title>
                  {{ scope.pulse }}
                </template>
                <span class="pulse-cell">{{ scope.pulse }}</span>
              </a-tooltip>
              <a-icon
                type="copy"
                class="copy-icon"
                title="复制"
                @click="copyToClipboard(scope.pulse)"
              />
            </template>
            <span v-else>/</span>
          </template>
        </a-table-column>
        <a-table-column
          key="exts"
          title="拓展信息"
          width="200"
        >
          <template #default="scope">
            <div v-if="scope.exts && scope.exts.length">
              <div
                v-for="ext in scope.exts"
                :key="ext.tag"
              >
                {{ ext.tag }}: {{ ext.value }}
              </div>
            </div>
            <span v-else>/</span>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div
      v-if="drawerData.modes && drawerData.modes.length"
      style="margin-top: 16px"
    >
      <h4>模式列表</h4>
      <a-table
        :data-source="drawerData.modes"
        row-key="id"
        :pagination="false"
        size="small"
        bordered
      >
        <a-table-column
          key="id"
          title="ID"
          data-index="id"
        />
        <a-table-column
          key="temperature"
          title="温度"
          data-index="temperature"
        />
        <a-table-column
          key="speed"
          title="风速"
          data-index="speed"
        />
      </a-table>
    </div>
    <div v-if="loading">
      <a-spin />
    </div>
    <a-empty
      v-if="!loading && !hasData"
      description="暂无按键和模式数据"
      style="margin-top: 120px"
    />
  </a-drawer>
</template>

<script>
export default {
  name: 'TestKeyDrawer',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    drawerData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasData() {
      return (this.drawerData.keys && this.drawerData.keys.length)
        || (this.drawerData.modes && this.drawerData.modes.length)
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制')
      }).catch(() => {
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('已复制')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.pulse-cell {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.copy-icon {
  margin-left: 4px;
  color: #1890ff;
  cursor: pointer;
  vertical-align: middle;
}
</style>
